import "./App.css";
import { Fragment } from "react";
import TelegramWidget from "./TelegramWidget";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Fragment>
          <Routes>
            <Route path="/" element={<TelegramWidget to="/auth" />} />
          </Routes>
        </Fragment>
      </Router>
      <header className="App-header"></header>
    </div>
  );
}

export default App;
